/**
 * @generated SignedSource<<983d766246d0d83518ed2256cde62d09>>
 * @relayHash 4aec197c59e251909f9d25f993ba247e
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/442.0.0-2023-12-13T10:06:08.437Z/PreloadedCheckoutDutiesQuery

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PreloadedCheckoutDutiesQuery$variables = {
  buyerId?: string | null;
  destinationCountry?: string | null;
  itemId?: string | null;
  shipmentQuoteId?: string | null;
};
export type PreloadedCheckoutDutiesQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"PreQuoteDutiesDescription_viewer">;
  };
};
export type PreloadedCheckoutDutiesQuery = {
  response: PreloadedCheckoutDutiesQuery$data;
  variables: PreloadedCheckoutDutiesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "buyerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "destinationCountry"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shipmentQuoteId"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PreloadedCheckoutDutiesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PreQuoteDutiesDescription_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "PreloadedCheckoutDutiesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "buyerId",
                "variableName": "buyerId"
              },
              {
                "kind": "Variable",
                "name": "destinationCountry",
                "variableName": "destinationCountry"
              },
              {
                "kind": "Variable",
                "name": "itemId",
                "variableName": "itemId"
              },
              {
                "kind": "Variable",
                "name": "shipmentQuoteId",
                "variableName": "shipmentQuoteId"
              }
            ],
            "concreteType": "CustomsDuties",
            "kind": "LinkedField",
            "name": "customsDuties",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "crossCustomsBorder",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "incoterm",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/442.0.0-2023-12-13T10:06:08.437Z/PreloadedCheckoutDutiesQuery",
    "metadata": {},
    "name": "PreloadedCheckoutDutiesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "617d9c112cee56d6439c26c18d6f159c";

export default node;
